export enum ResultsAction {
  SET_PROPERTY = 'SET_PROPERTY',         // 修改属性
  SET_RESULTS_LIST = 'SET_RESULTS_LIST'
}